import * as Styled from './styles'

export default function TitleFooter({ children }) {
  return <Styled.TitleFooter>{children}</Styled.TitleFooter>
}
